module.exports = __webpack_public_path__ + "static/background-3bdeddd3d843f012dde39faa94bb6987.jpg";